/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/no-unused-vars */
/* eslint-disable  @typescript-eslint/explicit-module-boundary-types */
import store from "@/store";
import {api} from "@/services/Api";
import router from "@/router";
import {USE_LOCAL_MENU} from "@/router/Menu";
import User from "@/entity/User";
import Role from "@/entity/Role";
import Partner from "@/entity/Partner";
import {helper} from "@/services/Helper";
import CryptoJSAesJson from "@/services/CryptoAes";
import {and} from "three/examples/jsm/nodes/shadernode/ShaderNodeBaseElements";
import impersonateService from "@/services/impersonateService";

class Auth {

    constructor() {
    }


    async login(username: string, password: string, captchaResponse = '') {
        const at = '' + Math.ceil((new Date()).getTime() / 1000)
        const result: any = await api.post(api.auth, 'auth/manager/login', {
            username: username,
            password: password,
            captcha: captchaResponse
        }, {
            headers: {
                At: at
            }
        });
        if (!result) {
            return false;
        }
        if (result && result.data && result.data.data) {
            const data = CryptoJSAesJson.decrypt(result.data.data, at)
            console.log(data)
            if (data) {
                return data;
            }
        }
        return false
    }

    loginData(data: any, redirect = true) {
        console.log('login data')
        console.log(data)
        if (data.token) {
            store.getters.menus()
            if (data.refreshToken) {
                localStorage.setItem('refreshToken', data.refreshToken)
                store.state.mainStore.userRefreshToken = data.refreshToken
            }
            if (data.token) {
                localStorage.setItem('userToken', data.token)
                store.state.mainStore.userToken = data.token
            }
            if (data.user) {
                console.log('set user')
                localStorage.setItem('user', JSON.stringify(data.user))
                store.state.mainStore.user = new User(data.user)
            }
            if (data.routes && !helper.empty(data.routes)) {
                localStorage.setItem('routes', JSON.stringify(data.routes))
            }
            // Menus charges depuis l'API auth (menus/menu_{tenant}.json) - editable sans rebuild
            // Fallback : Menu.ts statique si l'API ne renvoie rien
            // USE_LOCAL_MENU : on ignore le menu serveur et on garde Menu.ts (source du store)
            if (!USE_LOCAL_MENU && data.menus && !helper.empty(data.menus)) {
                localStorage.setItem('menus', JSON.stringify(data.menus))
                store.state.mainStore.menus = data.menus
            }
            if (data.settings && !helper.empty(data.settings)) {
                localStorage.setItem('settings', JSON.stringify(data.settings))
                store.state.settings = data.settings
            }

            let currentTenant: any = localStorage.getItem('currentTenant') ? JSON.parse(localStorage.getItem('currentTenant')!) : null
            if (data.tenants) {
                store.state.mainStore.tenants = []
                if (Array.isArray(data.tenants)) {
                    for (const t of data.tenants) {
                        store.state.mainStore.tenants.push({code: t.code, label: t.label})
                    }
                } else {
                    for (const key of Object.keys(data.tenants)) {
                        store.state.mainStore.tenants.push({code: key, label: data.tenants[key]})
                    }
                }
                if (store.state.mainStore.tenants.length == 1) {
                    currentTenant = store.state.mainStore.tenants[0]
                    localStorage.setItem('currentTenant', JSON.stringify(currentTenant))
                    store.state.mainStore.currentTenant = currentTenant
                } else if (currentTenant && currentTenant.code) {
                    // Rafraîchir currentTenant avec le format propre {code, label}
                    const match = store.state.mainStore.tenants.find((t: any) => t.code === currentTenant.code)
                    if (match) {
                        currentTenant = match
                        localStorage.setItem('currentTenant', JSON.stringify(currentTenant))
                        store.state.mainStore.currentTenant = currentTenant
                    }
                }
                localStorage.setItem('tenants', JSON.stringify(store.state.mainStore.tenants))
            }
            if (helper.empty(currentTenant)) {
                router.push({name: 'tenant-selector'})
                return
            }
            if (redirect) {
                router.push({name: 'home'})
            }
            return true;
        }
    }

    async impersonate(data: any) {
        try {
            await impersonateService.backupLocalStorage()
            // Effacer le currentTenant pour forcer la selection d'un tenant valide
            localStorage.removeItem('currentTenant')
            store.state.mainStore.currentTenant = null
            this.loginData(data, true)
        } catch (e) {
            console.log(e)
        }
    }

    exitImpersonate() {

    }

    async loadPartnerData() {
        const res = await api.get(api.core, 'api/partner/load/data')
        // console.log(res)
        if (res && res.data) {
            const partner = new Partner(res.data.partner)
            store.state.mainStore.partner = partner
            localStorage.setItem('partner', JSON.stringify(partner))
        }
    }

    async partnerLogin(username: string, password: string, captchaResponse = '') {
        const at = '' + Math.ceil((new Date()).getTime() / 1000)
        let post = {
            username: username,
            password: password,
            captcha: captchaResponse
        }
        post = CryptoJSAesJson.encrypt(post, at)
        const result = await api.post(api.auth, 'auth/partner/login', post, {headers: {At: at}});
        if (!result) {
            return false;
        }

        if (result && result.data && result.data.data) {
            const data = CryptoJSAesJson.decrypt(result.data.data, at)
            if (data) {
                return data;
            }
        }
        return false;
    }


    loadData() {
        const token = localStorage.getItem('userToken') || '';
        const refreshToken = localStorage.getItem('refreshToken') || '';
        store.state.userToken = token
        store.state.userRefreshToken = refreshToken
        return {token, refreshToken};
    }

    isConnected(): any {
        const data = this.loadData();
        if (!data) {
            return false;
        }
        return data.token;
    }

    isAdmin(): boolean {
        return this.hasRole('ROLE_ADMIN')
    }

    logout(): void {
        let route = 'login'
        if (this.hasRole('ROLE_MANAGER')) {
            route = 'login'
        } else if (this.hasRole('ROLE_PARTNER')) {
            route = 'partner-login'
        }
        // console.log(route)
        // return
        store.commit('logout');
        store.state.settings = null;
        localStorage.removeItem('user');
        localStorage.removeItem('userRefreshToken');
        localStorage.removeItem('token');
        localStorage.clear();
        // console.log('LOGOUT')
        if (router.currentRoute.name !== 'login') {
            router.push({name: route});
        }
    }

    getTenants() {
        const tenants = localStorage.getItem('tenants')
        if (tenants) {
            return JSON.parse(tenants)
        }
        // const data = this.loadData()
        // const parsed = this.parseJwt(data.token)
        // if (parsed && parsed.tenants) {
        //     return parsed.tenants
        // }
        return []
    }

    initSessionRoles() {
        if (!sessionStorage.getItem('sessionRoles')) {
            sessionStorage.setItem('sessionRoles', JSON.stringify([]));
        }
    }

    addSessionRole(role: any) {
        this.initSessionRoles();
        let roles = JSON.parse(sessionStorage.getItem('sessionRoles')!);

        roles = roles.filter((r: any) => {
            return r.code !== role.code
        })
        roles.push(role);
        sessionStorage.setItem('sessionRoles', JSON.stringify(roles));
    }

    removeSessionRole(role: any) {
        this.initSessionRoles();
        const roles = JSON.parse(sessionStorage.getItem('sessionRoles')!).filter((r: any) => r !== role);
        sessionStorage.setItem('sessionRoles', JSON.stringify(roles));
    }

    getSessionRoles() {
        this.initSessionRoles();
        return JSON.parse(sessionStorage.getItem('sessionRoles')!);
    }


    hasRole(role: any, tenantCode: any = null) {

        if (typeof role === 'object' && role.hasOwnProperty('code')) {
            role = role.code
        }

        const user = this.getCurrentUser()
        let roles = []
        if (user) {
            roles = user.roles
        }
        if(!roles){
            return false;
        }
        const {token} = this.loadData()
        const data = this.parseJwt(token)
        if (!tenantCode) {
            const currentTenant = store.state.mainStore.currentTenant
            if (currentTenant) {
                tenantCode = currentTenant.code
            }
        }
        if (!tenantCode) {
            tenantCode = helper.generateId();
        }
        tenantCode = tenantCode.toUpperCase()
        const tenantRole = role + '_' + tenantCode
        const sessionRoles = this.getSessionRoles()
        // console.log(tenantRole)
        if (role === 'ROLE_UNKNOW' || role === 'ROLE_UNKNOW_' + tenantCode) {
            return helper.empty(sessionRoles) && helper.empty(data.roles)
        }
        for (let sessionRole of sessionRoles) {
            if (role === sessionRole.code || sessionRole.code === tenantRole) {
                return true
            }
        }
        if (tenantRole) {
            for (let r of roles) {
                if (role === r || r === tenantRole) {
                    return true
                }
            }
        }
        // return false
        const adminRole = 'ROLE_ADMIN_' + tenantCode
        const isAdmin = roles.includes(adminRole) || roles.includes(tenantRole)
        return isAdmin
    }

    userHasRole(user: User, role: string) {

        let userRoles: any[] = []
        for (let r of user.roles) {
            if (role === r) {
                return true
            }
        }
        return false
        //user.roles.includes('ROLE_ADMIN')
    }

    partnerHasRole(partner: Partner, role: string) {

        if (partner && partner.roles) {
            let userRoles: any[] = []
            for (let r of partner.roles) {
                if (role === r) {
                    return true
                }
            }
            return false
        }
        //user.roles.includes('ROLE_ADMIN')
    }


    getCurrentUser(): any {
        const user = localStorage.getItem('user')
        if (user) {
            return JSON.parse(user)
        }
        const data = this.loadData()
        const userData = this.parseJwt(data.token)
        if (userData) {
            return new User(userData)
        }
        return null
    }

    getRoles() {
        const {token} = this.loadData()
        const data = this.parseJwt(token)
        return data.roles
    }

    hasRoles(roles: []) {
        for (let role of roles) {
            if (!this.hasRole(role)) {
                return false;
            }
        }
        return true // || this.hasRole('ROLE_ADMIN')
    }

    checkRoleTabs(roles: any[]) {
        for (let andTab of roles) {
            if (this.hasRoles(andTab)) {
                // console.log('has roles ', andTab)
                return true
            }
        }
        return false
    }

    hasOneRole(roles: []) {
        for (let role of roles) {
            if (this.hasRole(role)) {
                return true;
            }
        }
        return this.hasRole('ROLE_ADMIN')
    }

    parseJwt(token: string): any {
        if (!token) {
            // this.logout()
            // console.log(token + ' token is empty');
            return {roles: []};
        }
        let base64Url = token.split('.')[1];
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }
}

export const auth = new Auth();
